import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { ContactInteraction } from "./types";

interface DeleteConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  interaction: ContactInteraction;
}

const DeleteConfirmationModal = ({ onClose, onConfirm, interaction }: DeleteConfirmationModalProps) => (
  <Dialog open onClose={onClose}>
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      Are you sure you want to delete this interaction?
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmationModal;
